<template>
    <div>
        <vx-card class="widget" title="Demerge Action" title-color="black">
            <div>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mb-3">
                        <SelectForeign :model.sync="data.share" label="Select Share for Demerger" :multiple="false"
                            :load_initial="true" :label_keys="['name']" label_class="mb-0" input_class="mt-0 bg-white"
                            :show_id_in_label="false" placeholder="Type to Search" list_length="10000"
                            :endpoint="$store.state.apiendpoints.share_list" :use_id_as_value="true" :disabled="loading" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.share">
                            {{ api_errors.share.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="pl-0 pr-1 mb-3">
                        <SelectDate :selectedDate.sync="data.applicable_date" label="Applicable Date"
                            placeholder="Select Date" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.applicable_date">
                            {{ api_errors.applicable_date.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="pl-0 pr-1">
                        <label class="vs-input--label">Old Cost Allocation Percent</label>
                        <vs-input v-model="data.action_info.old_cost_allocation" placeholder="Enter the value" min="1"
                            step="0.01" class="w-full" type="number" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.old_cost_allocation">
                            {{ api_errors.old_cost_allocation.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="p-0 mb-3">
                    <label class="vs-input--label block mb-1">Round Off Method</label>
                    <ul class="centerx">
                        <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                            <li>
                                <vs-radio default v-model="data.action_info.round_off" vs-value="floor">Floor</vs-radio>
                            </li>
                        </vs-col>
                        <vs-col class="pl-0" vs-xs="12" vs-sm="3" vs-lg="3">
                            <li>
                                <vs-radio v-model="data.action_info.round_off" vs-value="ceil">Ceiling</vs-radio>
                            </li>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                            <li>
                                <vs-radio v-model="data.action_info.round_off" vs-value="round">Round Off</vs-radio>
                            </li>
                        </vs-col>
                    </ul>
                </vs-col>
            </div>
            <div>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-2 mb-3">
                        <vs-table :data="data.action_info.demerge_list" class="table-custom">
                            <vs-tr>
                                <vs-th style="width: 40%;">Share</vs-th>
                                <vs-th style="width: 20%;">Old Quantity</vs-th>
                                <vs-th style="width: 20%;">New Quantity</vs-th>
                                <vs-th style="width: 20%;">New Cost Allocation</vs-th>
                                <vs-th></vs-th>
                                <vs-th></vs-th>
                            </vs-tr>
                            <template>
                                <template v-for="(item, index) in data.action_info.demerge_list">
                                    <vs-tr :key="index">
                                        <vs-td vs-xs="12" vs-sm="4" vs-lg="4">
                                            <SelectForeign :model.sync="data.action_info.demerge_list[index].share_demerge"
                                                :multiple="false" :load_initial="true" :label_keys="['name']"
                                                label_class="mb-0" input_class="mt-0 bg-white" :show_id_in_label="false"
                                                placeholder="Type to Search"
                                                :endpoint="$store.state.apiendpoints.share_list" :use_id_as_value="false"
                                                :disabled="loading" 
                                                list_length="10000"
                                            />
                                            <small class="block text-danger mt-1"
                                                v-if="api_errors && api_errors[index] && api_errors[index].share_demerge">
                                                {{ api_errors[index].share_demerge.join(', ') }}
                                            </small>
                                        </vs-td>
                                        <vs-td>
                                            <vs-input v-model="item.old_qty_ratio" placeholder="Enter the value"
                                                class="w-full" type="number" min="1" step="0.01" />
                                            <small class="block text-danger mt-1"
                                                v-if="api_errors && api_errors[index] && api_errors[index].old_qty_ratio">
                                                {{ api_errors[index].old_qty_ratio.join(', ') }}
                                            </small>
                                        </vs-td>
                                        <vs-td>
                                            <vs-input v-model="item.new_qty_ratio" placeholder="Enter the value"
                                                class="w-full" type="number" min="1" step="0.01" />
                                            <small class="block text-danger mt-1"
                                                v-if="api_errors && api_errors[index] && api_errors[index].new_qty_ratio">
                                                {{ api_errors[index].new_qty_ratio.join(', ') }}
                                            </small>
                                        </vs-td>
                                        <vs-td>
                                            <vs-input v-model="item.new_cost_allocation" min="1" step="0.01"
                                                placeholder="Enter the value" class="w-full" type="number" />
                                            <small class="block text-danger mt-1"
                                                v-if="api_errors && api_errors[index] && api_errors[index].new_cost_allocation">
                                                {{ api_errors[index].new_cost_allocation.join(', ') }}
                                            </small>
                                        </vs-td>
                                        <vs-td class="text-right">
                                            <vs-button class="ml-3" color="danger" type="filled" @click="doDelete(index)"
                                                size="small">Delete</vs-button>
                                        </vs-td>
                                        <!-- <vs-td>
                                            <vs-button class="ml-3" color="primary" type="filled"
                                                size="small">Preview</vs-button>
                                        </vs-td> -->
                                    </vs-tr>
                                </template>
                            </template>
                        </vs-table>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-3 mb-3">
                        <vs-button class="w-full" @click="add_demerge_share" color="primary" type="filled"
                            :disabled="loading">Add a Share</vs-button>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="pl-0 pr-1 mt-3 mb-3">
                        <vs-button class="w-full" @click="save" color="primary" type="filled"
                            :disabled="data.action_info.demerge_list.length === 0">Submit</vs-button>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";

export default {
    props: {
        embedded_mode: {
            default: false,
        },
        embedded_filters: {
            default: null,
        },
    },
    data() {

        return {
            data: {
                share: null,
                applicable_date: null,
                action_info: {
                    old_cost_allocation: null,
                    demerge_list: [],
                    round_off: "floor"
                },
                corporate_action_type: "demerge",
            },
            demerge_data: {
                share_demerge: null,
                new_cost_allocation: null,
                old_qty_ratio: null,
                new_qty_ratio: null
            },
            loading: false,
            api_errors: {}
        };
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.demerge_id'(newV) {
            this.init()
        },
    },
    methods: {
        init() {
            this.demerge_id = this.$route.params.demerge_id
            if (this.$route.params.demerge_id) {
                this.loadData()
            }
        },
        loadData() {
            this.loading = true

            Request(this, 'GET', this.$store.state.apiendpoints.corporate_action_rud + this.demerge_id + "/").then(
                (res) => {
                    this.data = res
                    this.demerge_id = res.id
                    this.loading = false
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$router.push("/");
                }
            )
        },
        add_demerge_share() {
            this.data.action_info.demerge_list.push(this.demerge_data)
            this.demerge_data = {
                share_demerge: null,
                new_cost_allocation: null,
                old_qty_ratio: null,
                new_qty_ratio: null
            }
            console.log(this.data);
        },
        doDelete(index) {
            this.data.action_info.demerge_list.splice(index, 1)
        },
        checking_for_required_fields() {
            if (!this.data.share) {
                this.api_errors = {
                    "share": [
                        "Share is required.",
                    ]
                }
                return true
            }
            if (!this.data.applicable_date) {
                this.api_errors = {
                    "applicable_date": [
                        "Applicable Date is required.",
                    ]
                }
                return true
            }
            if (!this.data.action_info.old_cost_allocation) {
                this.api_errors = {
                    "old_cost_allocation": [
                        "Old Cost Allocation is required.",
                    ]
                }
                return true
            } else {
                let sum = parseFloat(this.data.action_info.old_cost_allocation)
                console.log("sum");
                console.log(sum);
                this.data.action_info.demerge_list.forEach(obj => {
                    if (obj.new_cost_allocation) {
                        sum += parseFloat(obj.new_cost_allocation)
                    }
                })
                console.log(sum);
                if (sum != 100) {
                    console.log("error sum");
                    this.api_errors = {
                        "old_cost_allocation": [
                            "Cost Allocation Percent Total Sum should be 100",
                        ]
                    }
                    return true
                }
            }
            for (let [index, val] of this.data.action_info.demerge_list.entries()) {
                if (!val.share_demerge) {
                    this.api_errors = {}
                    this.api_errors[index] = {
                        "share_demerge": [
                            "Share is required.",
                        ]
                    }
                    return true
                }
                if (!val.old_qty_ratio) {
                    this.api_errors = {}
                    this.api_errors[index] = {
                        "old_qty_ratio": [
                            "Old Quantity Ratio is required.",
                        ]
                    }
                    return true
                }
                if (!val.new_qty_ratio) {
                    this.api_errors = {}
                    this.api_errors[index] = {
                        "new_qty_ratio": [
                            "New Quantity Ratio is required.",
                        ]
                    }
                    return true
                }
                if (!val.new_cost_allocation) {
                    this.api_errors = {}
                    this.api_errors[index] = {
                        "new_cost_allocation": [
                            "New Cost Allocation is required.",
                        ]
                    }
                    return true
                }
            }

            return false
        },
        save() {
            console.log(this.checking_for_required_fields());
            console.log(this.api_errors);
            if (this.checking_for_required_fields()) return
            let $this = this
            let url = $this.$store.state.apiendpoints.corporate_action, request_method = "POST";
            if (this.demerge_id) {
                url = $this.$store.state.apiendpoints.corporate_action_rud + this.demerge_id + "/";
                request_method = "PUT";
            }
            this.submit_disabled = true
            Request($this, request_method, url, null, this.data).then(
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({ name: 'corporate-action-list' })
                },
                (err) => {
                    if (err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            );
        },
    }
};
</script>